import Vue from 'vue'
import { estado as routing } from '../util/routes'

export default {
  state: {
    estado: {},
    estados: [],
    paginateEstados: {
      data: []
    },
    estadoPage: 1,
    estadoFilter: ''
  },
  mutations: {
    setEstado: (state, payload) => {
      state.estado = payload
    },
    setEstados: (state, payload) => {
      state.estados = payload
    },
    setPaginateEstados: (state, payload) => {
      state.paginateEstados = payload
    },
    setEstadoPage: (state, payload = 1) => {
      state.estadoPage = payload
    },
    setEstadoFilter: (state, payload = '') => {
      state.estadoFilter = payload
    }
  },
  actions: {
    async getPaginateEstados ({ commit, state }, payload) {
      commit('setPaginateEstados', {
        data: []
      })
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          page: state.estadoPage,
          filter: state.estadoFilter
        }
      })

      commit('setPaginateEstados', data)
    },
    async getEstados ({ commit }, payload) {
      commit('setEstados', [])
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          limit: 0
        }
      })
      commit('setEstados', data)
    },
    async getEstado ({ commit }, { id }) {
      commit('setEstado', {})
      const { data } = await Vue.axios.get(`${routing}/${id}`)
      commit('setEstado', data)
    },
    async postSaveEstado ({ state }) {
      const { estado } = state
      if (estado.id) {
        return Vue.axios.put(`${routing}/${estado.id}`, estado)
      }
      return Vue.axios.post(`${routing}`, estado)
    },
    async deleteEstado ({ state }) {
      const { estado } = state
      return Vue.axios.delete(`${routing}/${estado.id}`)
    }
  },
  getters: {
    estado: ({ estado }) => estado,
    estadoPage: ({ estadoPage }) => estadoPage,
    estadoFilter: ({ estadoFilter }) => estadoFilter,
    estados: ({ estados }) => estados,
    paginateEstados: ({ paginateEstados }) => paginateEstados
  }
}
